module.exports = __webpack_public_path__ + "img/Group 19.51b023d7.png";